import React from 'react';
import PropTypes from 'prop-types';
import {CBJustification} from './CBJustification.jsx';
import {OptionalDocuments} from './OptionalDocuments.jsx';
import {BrickContext} from 'olympe';

/**
 * @param {AttachmentsDetails.propTypes} props
 * @return {JSX.Element}
 * @constructor
 */
export function AttachmentsDetails(props) {
    return (
        <div className={'pr-editor-centered-submodule'}>
            <p className={'pr-editor-section-title'} style={{marginTop: '40px'}}>Attachments & comments</p>
            <CBJustification prTag={props.prTag} context={props.context} currentTab={props.currentTab}/>
            <OptionalDocuments prTag={props.prTag} context={props.context}/>
        </div>
    );
}

AttachmentsDetails.propTypes = {
    prTag: PropTypes.string,
    context: PropTypes.instanceOf(BrickContext).isRequired,
    currentTab: PropTypes.string,
};
